require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-sass-master-dale-sande-brings-expertise-to-4-night-class-this-february.json") })
        }
      }, "path---blog-sass-master-dale-sande-brings-expertise-to-4-night-class-this-february");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-sass-master-dale-sande-brings-expertise-to-4-night-class-this-february!./.cache/json/blog-sass-master-dale-sande-brings-expertise-to-4-night-class-this-february.json
// module id = 1029
// module chunks = 231608221292675